module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_2750_Active@1x-e7ff5c77f3d0368980f529a49828cf3e.png";